<template>
  <div class="personal">
    <div class="personal_head">
      个人资料
      <span></span>
    </div>
    <div class="personal_center">
      <div class="personal_left">
        <div
          class="perleft_head left_head"
          :style=" {backgroundImage:'url('+headimg+')'}"
          v-show="ischangehead==1"
          @click.stop="changeheadimg(1)"
        >
          <!-- <input type="file" class="head_flie" accept="image/jpg, image/jpeg, image/png" @change="head_submit"> -->
        </div>
        <div class="circleProgress_wrapper left_head" v-show="ischangehead==2">
          <div class="perleft_head" :style=" {backgroundImage:'url('+headimg+')'}">
            <p>正在上传</p>
          </div>
          <div class="wrapper right">
            <div class="circleProgress rightcircle"></div>
          </div>
          <div class="wrapper left">
            <div class="circleProgress leftcircle"></div>
          </div>
        </div>
        <div
          class="success_head left_head"
          :style=" {backgroundImage:'url('+headimg+')'}"
          v-show="ischangehead==3"
        >
          <p>{{head_text}}</p>
        </div>
        <p class="left_title">修改头像</p>
      </div>
      <div class="personal_right">
        <p class="change_title">
          <span></span>修改昵称
        </p>
        <div class="change_centent" style="margin-bottom:60px;">
          <p>
            <span>*</span>昵称
          </p>
          <input type="text" v-model="username" @blur="blur_name" />
          <div class="dis_p">{{dis_p4}}</div>
        </div>
        <p class="change_title">
          <span></span>修改密码
        </p>
        <div class="change_centent">
          <p>旧密码</p>
          <input
            type="password"
            placeholder="输入旧密码"
            v-model="oldpwd"
            @blur="blur_old"
            @keyup.enter="user_submit"
          />
          <div class="dis_p">{{dis_p1}}</div>
        </div>
        <div class="change_centent">
          <p>新密码</p>
          <input
            type="password"
            placeholder="输入新密码"
            v-model="newpwd"
            @blur="blur_new"
            @keyup.enter="user_submit"
          />
          <div class="dis_p">{{dis_p2}}</div>
        </div>
        <div class="change_centent">
          <p>确认密码</p>
          <input
            type="password"
            placeholder="确认新密码"
            v-model="confirmpwd"
            @blur="blur_confirm"
            @keyup.enter="user_submit"
          />
          <div class="dis_p">{{dis_p3}}</div>
        </div>
        <button
          v-show="!cansubmit"
          class="change_submit"
          @click="user_submit"
          :disabled="isdosubmit"
        >保存</button>
        <button v-show="cansubmit" class="notcansubmit change_submit">保存</button>
      </div>
    </div>
    <my-upload
      @crop-success="cropSuccess"
      v-model="show"
      :width="200"
      :height="200"
      img-format="png"
      :size="size"
      langType="zh"
      :noRotate="false"
      field="Avatar1"
      :noSquare="true"
    ></my-upload>
  </div>
</template>
<script>
import "babel-polyfill"; // es6 shim
import myUpload from "vue-image-crop-upload";
import { addstamp } from "../../util/stamp";
export default {
  data() {
    return {
      userid: null,
      ischangehead: 1,
      username: null,
      headimg: null,
      show: false,
      size: 2.1,
      oldpwd: null,
      newpwd: null,
      confirmpwd: null,
      dis_p1: "",
      dis_p2: "",
      dis_p3: "",
      dis_p4: "",
      cansubmit: false,
      isdosubmit: false,
      head_text:'上传成功'
    };
  },
  components: {
    // "my-upload": myUpload
  },
  created() {
    this.userid = parseInt(this.$store.state.user_id);
    this.username = this.$store.state.username;
    this.headimg = this.$store.state.head_img;
  },
  methods: {
    changeheadimg(num) {
      // $('.head_flie').click()
      // console.log(num)
      this.show = !this.show;
    },
    head_submit(e) {
      // let that = this;
      // let $target = e.target || e.srcElement;
      // let file = $target.files[0];
      // console.log(file);
      // var reader = new FileReader();
      // reader.onload = data => {
      //   let res = data.target || data.srcElement;
      //   this.headimg = res.result;
      // };
      // reader.readAsDataURL(file);
      // that.ischangehead = 2;
      // setTimeout(function() {
      //   that.ischangehead = 3;
      //   setTimeout(function(){
      //     that.ischangehead = 1
      //   },4000)
      // }, 3000);
    },
    cropSuccess(imgDataUrl, field) {
      // console.log('-------- crop success --------');
      // console.log(imgDataUrl);
      // console.log(field);
      let that = this;
      this.headimg = imgDataUrl;
      that.ischangehead = 2;
      // setTimeout(function() {
      //   that.ischangehead = 3;
      //   setTimeout(function() {
      //     that.ischangehead = 1;
      //   }, 4000);
      // }, 3000);

      let params = {
        user_id: this.userid,
        head_img: this.headimg
      };
      var time = new Date()
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      // console.log(params)
      let url = "head_img/" + this.userid;
      this.$axios.put(url, params).then(function(res) {
        // console.log(res)
        if(res.data.status_code == 200){
          that.headimg = res.data.data.head_img;
          that.$store.commit("setheadimg", that.headimg);
          that.$store.commit("settimestamp", time.getTime());
          that.$router.go(0)
        }else{
          that.head_text = '上传失败'
        }
          that.ischangehead = 3
      });
    },
    blur_name() {
      if (!this.username) {
        this.dis_p4 = "请输入必填昵称";
        this.cansubmit = true;
      } else {
        this.dis_p4 = "";
        this.cansubmit = false;
      }
    },
    blur_old() {
      if ((!this.oldpwd && this.newpwd) || (!this.oldpwd && this.confirmpwd)) {
        this.dis_p1 = "请输入旧密码";
      } else {
        this.dis_p1 = "";
      }
    },
    blur_new() {
      if ((!this.newpwd && this.confirmpwd) || (!this.newpwd && this.oldpwd)) {
        this.dis_p2 = "请输入新密码";
      } else {
        this.dis_p2 = "";
      }
    },
    blur_confirm() {
      if (
        (!this.confirmpwd && this.newpwd) ||
        (!this.confirmpwd && this.oldpwd)
      ) {
        this.dis_p3 = "请再次输入密码";
      } else if (this.confirmpwd && this.newpwd) {
        if (this.confirmpwd != this.newpwd) {
          this.dis_p3 = "两次输入密码不一致!";
        }
      } else {
        this.dis_p3 = "";
      }
      // if(!this.confirmpwd&&this.newpwd||!this.confirmpwd&&this.oldpwd){
      //   this.dis_p3 = '请再次输入密码'
      // }else if(this.confirmpwd != this.newpwd){
      //   this.dis_p3 = '两次输入密码不一致!'
      // }else{
      //   this.dis_p3 = ''
      // }
    },
    user_submit() {
      let that = this;
      if(!this.cansubmit){
        var params = {}
        let issubmit = this.checksubmit()
        this.isdosubmit = true
        if(issubmit == 2){
          params = {
            user_id: this.userid,
            name:this.username,
            old_password:this.oldpwd,
            password:this.newpwd
          }
        }else if(issubmit == 3){
          params = {
            user_id: this.userid,
            name:this.username
          }
        }else if(issubmit == 1){
          this.isdosubmit = false
        }
      if(issubmit !== 1){
        var sign = addstamp(params)
        delete params.token
        params['sign'] = sign
        // console.log(params)
        let url = 'user_info/'+this.userid
        this.$axios.put(url,params)
        .then(function(res){
           that.$store.commit("setusername", that.username);
            if (res.data.status_code == 200) {
              if (issubmit == 2) {
                that.$message({
                  message: "个人信息修改成功！请重新登录",
                  type: "success",
                  duration: 4000
                });
                localStorage.removeItem("user_id");
                that.$store.commit("setroued", that.$route.path);
                setTimeout(function() {
                  that.$router.push({
                    name: "login",
                    params: {
                      again: "setpwd"
                    }
                  });
                }, 3000);
              } else if (issubmit == 3) {
                that.$message({
                  message: "个人资料已更新",
                  type: "success",
                  duration: 2000
                });
                // setTimeout(function() {
                //   that.$router.go(0)
                // }, 2000);
              }
            } else if (res.data.status_code == 4001) {
              that.oldpwd = null;
              that.dis_p1 = "密码错误!请重新输入";
            }
            that.isdosubmit = false;

        })
      }
      }
    },
    checksubmit() {
      let issubmit = 1;
      if (this.oldpwd && this.newpwd && this.confirmpwd) {
        if (this.confirmpwd != this.newpwd) {
          this.dis_p3 = "两次输入密码不一致!";
          issubmit = 1;
        } else {
          if (this.oldpwd == this.newpwd) {
            this.dis_p2 = "新密码不可与旧密码一致!";
            issubmit = 1;
          } else {
            issubmit = 2;
          }
        }
      } else if (!this.oldpwd && !this.newpwd && !this.confirmpwd) {
        this.dis_p1 = "";
        this.dis_p2 = "";
        this.dis_p3 = "";
        issubmit = 3;
      } else {
        if (!this.oldpwd) {
          this.dis_p1 = "请输入旧密码";
        }
        if (!this.newpwd) {
          this.dis_p2 = "请输入新密码";
        }
        if (!this.confirmpwd) {
          this.dis_p3 = "请再次输入密码";
        }
        issubmit = 1;
      }
      return issubmit;
    }
  },
  watch: {
    username() {
      if (!this.username) {
        this.cansubmit = true;
      } else {
        this.cansubmit = false;
      }
    },
    oldpwd() {
      // this.checksubmit()
    },
    newpwd() {
      // this.checksubmit()
    },
    confirmpwd() {
      // this.checksubmit()
    }
  }
};
</script>
<style lang="scss" scoped>
.personal {
  width: 1200px;
  border: 1px solid transparent;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 57px;
  background: #fff;
  padding-bottom: 1px;
  .personal_head {
    width: 100px;
    font-size: 24px;
    font-family: Alibaba PuHuiTi;
    font-weight: bold;
    color: #333;
    margin-left: 60px;
    margin-top: 40px;
    position: relative;
    z-index: 2;
    span {
      width: 100%;
      height: 6px;
      display: inline-block;
      position: absolute;
      bottom: 3px;
      left: 0;
      z-index: -1;
      background: #e6522b;
    }
  }
  .personal_center {
  padding-bottom: 1px;
    // display: flex;
    margin: 42px 0px;
    .personal_left {
      width: 299px;
      display: inline-block;
      vertical-align: top;
      .left_head {
        margin: 64px 0px 14px 120px;
        text-align: center;
        vertical-align: middle;
      }
      .perleft_head {
        width: 104px;
        height: 104px;
        border-radius: 50%;
        border: 8px solid #dcdcdc;
        background: no-repeat center center;
        background-size: cover;
        cursor: pointer;
        overflow: hidden;
        p {
          height: 104px;
          line-height: 104px;
          color: #fff;
          text-align: center;
          background: rgba(0, 0, 0, 0.35);
        }
      }

      .success_head {
        width: 104px;
        height: 104px;
        border-radius: 50%;
        overflow: hidden;
        border: 8px solid #ff6d47;
        background: no-repeat center center;
        background-size: cover;
        cursor: pointer;
        p {
          height: 104px;
          line-height: 104px;
          color: #fff;
          text-align: center;
          background: rgba(0, 0, 0, 0.35);
          // img{

          // }
        }
      }

      .left_title {
        text-align: center;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-indent: 60px;
      }
      .head_flie {
        display: none;
      }
    }
    .personal_right {
      display: inline-block;
      width: 896px;
      height: 633px;
      border-left: 1px solid #dcdcdc;
      // border: 1px solid red;
      box-sizing: border-box;
      position: relative;
      padding: 20px 0px 0px 58px;
      .change_title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        span {
          width: 8px;
          height: 8px;
          display: inline-block;
          background: rgba(201, 154, 130, 1);
          border-radius: 50%;
          margin-right: 4px;
          margin-bottom: 2px;
        }
      }
      .change_centent {
        // display: flex;
        margin-top: 30px;
        position: relative;
        p {
          display: inline-block;
          width: 65px;
          height: 41px;
          line-height: 41px;
          text-align: right;
          margin: 0px 18px 0px 9px;
          // border: 1px solid red;
          span {
            color: red;
            margin-right: 2px;
          }
        }
        input {
          width: 249px;
          height: 41px;
          border: none;
          display: inline-block;
          background: rgba(237, 237, 237, 1);
          border-radius: 21px;
          outline: none;
          text-indent: 18px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .dis_p {
          width: 325px;
          position: absolute;
          bottom: -25px;
          left: 0;
          font-size: 14px;
          text-align: right;
          color: red;
        }
      }
      .change_submit {
        width: 177px;
        height: 44px;
        background: rgba(230, 82, 43, 1);
        border: none;
        color: #fff;
        font-size: 18px;
        border-radius: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        position: absolute;
        bottom: 18px;
        left: 158px;
        outline: none;
        cursor: pointer;
      }
      .notcansubmit {
        background: #aaa;
        cursor: not-allowed;
      }
    }
  }
}
</style>
<style>
.circleProgress_wrapper {
  width: 120px;
  height: 120px;
  position: relative;
  /* border: 1px solid #ddd; */
}

.wrapper {
  width: 60px;
  height: 120px;
  position: absolute;
  top: 0;
  overflow: hidden;
}

.right {
  right: 0;
}

.left {
  left: 0;
}

.circleProgress {
  width: 104px;
  height: 104px;
  border: 8px solid #f36843;
  border-radius: 50%;
  position: absolute;
  top: 0;
  -webkit-transform: rotate(45deg);
}

.rightcircle {
  border-top: 8px solid #ddd;
  border-right: 8px solid #ddd;
  right: 0;
  -webkit-animation: circleProgressLoad_right 3s linear infinite;
}

.leftcircle {
  border-bottom: 8px solid #ddd;
  border-left: 8px solid #ddd;
  left: 0;
  -webkit-animation: circleProgressLoad_left 3s linear infinite;
}

@-webkit-keyframes circleProgressLoad_right {
  0% {
    -webkit-transform: rotate(45deg);
  }

  50% {
    -webkit-transform: rotate(225deg);
  }

  100% {
    -webkit-transform: rotate(225deg);
  }
}

@-webkit-keyframes circleProgressLoad_left {
  0% {
    -webkit-transform: rotate(45deg);
  }

  50% {
    -webkit-transform: rotate(45deg);
  }

  100% {
    -webkit-transform: rotate(225deg);
  }
}
.vue-image-crop-upload .vicp-wrap {
  width: 500px !important;
}
/* .vue-image-crop-upload .vicp-wrap .vicp-operate a{
  color:#E6522B !important;
}
.input[type="range"]{
  color: #E6522B !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/page/personal.vue